import { gsap } from 'gsap';

const cursor = () =>  {
  const cursor = document.querySelector('#cursor');

  gsap.set(cursor, {xPercent: -50, yPercent: -50});

  let xTo = gsap.quickTo(cursor, "x", {duration: 0.4, ease: "power3"}),
      yTo = gsap.quickTo(cursor, "y", {duration: 0.4, ease: "power3"});

  window.addEventListener("mousemove", e => {
    xTo(e.clientX);
    yTo(e.clientY);
  });

  document.addEventListener('mouseenter', (e: any) => {
    if (e.target.matches === undefined) return;
    if (e.target.matches('a, button')) {
      cursor.classList.add('active');
    }
  }, true)

  document.addEventListener('mouseleave', (e: any) => {
    if (e.target.matches === undefined) return;
    if (e.target.matches('a, button')) {
      cursor.classList.remove('active');
    }
  }, true)

  document.addEventListener('touchstart', () => {
    (cursor as HTMLElement).style.display = 'none';
  })
}


export class CCursor extends HTMLElement {
  connectedCallback() {
    cursor();
  }
}

customElements.define('c-cursor', CCursor);